import { PopOutController } from './popOutController';

export function initialisePopOutController() {
    let popOutController = new PopOutController();
    (<any>window).popOutController = popOutController;
}
